// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/logo.png'),
    logoStyle: { height: 55 },
    heroImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/heroLarge.png'),
    exploreImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/residence-inn/exploreLarge.png'),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.RIBM,
      },
      secondary: {
        main: '#502b3a',
      },
      primaryBtnHover: {
        main: '#294F65',
      },
      buttonText: {
        main: '#ffffff',
      },
      interaction: {
        main: '#266f97',
      },
      text: {
        primary: '#000',
      },
      link: {
        primary: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'SackersGothicStd-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: 1.11,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'SackersGothicStd-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'SackersGothicStd-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'SackersGothicStd-Medium',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
